// Decides whether to show the login re-acceptance gate for a user.
//
// Product decision (confirmed): a MISSING pointer is NOT stale — existing users
// who signed up before the consent system are left alone. We only prompt when a
// user previously recorded a version AND that version is no longer current
// (i.e. the document was materially changed and its constant was bumped).
//
// Pure + side-effect free so it can be unit-tested without auth/Firestore.
const isStale = (accepted, current) =>
    typeof accepted === 'string' && accepted.length > 0 && accepted !== current

const needsReacceptance = (userDoc, { termsVersion, privacyVersion }) => {
    const terms = !!userDoc && isStale(userDoc.AcceptedTermsVersion, termsVersion)
    const privacy = !!userDoc && isStale(userDoc.AcceptedPrivacyVersion, privacyVersion)
    return { needed: terms || privacy, terms, privacy }
}

export default needsReacceptance
